import { render, staticRenderFns } from "./dictionaryInfo.vue?vue&type=template&id=21800e72&"
import script from "./dictionaryInfo.vue?vue&type=script&lang=js&"
export * from "./dictionaryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports